import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Box } from "@mui/material";
import React from "react";

const AccountGuardModal = (props) => {

	const handleClose = () => {
		props.onClose()
	};
	
	return (
		<Dialog
			open={props.open}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
		>
			<DialogTitle id="alert-dialog-title">
				Service Unavailable
			</DialogTitle>
			<DialogContent>
				<Box sx={{ textAlign: "center", marginTop: "1em", marginBottom: "1em" }}>
					{`This service is not currently available for your account.`}<br/>
					{`Please contact customer support.`}
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>OK</Button>
			</DialogActions>
		</Dialog>
	);

}

export default AccountGuardModal;